var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row align-items-center" }, [
    _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "nav-tabs-wrapper coupled bb-0 mb-3" }, [
        _c(
          "ul",
          { staticClass: "nav nav-tabs" },
          _vm._l(_vm.tabs, function (page) {
            return _c("router-link", {
              key: page,
              attrs: {
                id: page,
                exact: "",
                to: _vm.getTabRoute(page),
                custom: "",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (ref) {
                      var navigate = ref.navigate
                      var isExactActive = ref.isExactActive
                      return [
                        _c(
                          "li",
                          {
                            staticClass: "nav-item position-relative",
                            class: {
                              "navbar-active":
                                isExactActive ||
                                (_vm.tabIsSettings && page === "application"),
                            },
                            attrs: { role: "link" },
                            on: {
                              click: navigate,
                              keypress: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return navigate.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "nav-link grey-text text-darken-3 clickable",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.getTabTitle(page)) +
                                    "\n              "
                                ),
                                page === "document"
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          transform: "translateX(50%)",
                                        },
                                        attrs: {
                                          id: "documents-automation-tooltip",
                                        },
                                      },
                                      [
                                        _c("icon", {
                                          staticClass: "tooltip-info",
                                          attrs: { name: "question-circle" },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-auto mb-3" }, [
      _c(
        "div",
        { attrs: { id: "app-automation-settings-button-container" } },
        [
          _vm.shouldShowSettings
            ? [
                _c("router-link", {
                  key: "settings",
                  attrs: {
                    tag: "button",
                    to: _vm.settingsToggleRoute,
                    custom: "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var navigate = ref.navigate
                          return [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-sm btn-white d-none d-lg-block",
                                class: { "btn-primary": _vm.tabIsSettings },
                                attrs: { role: "link" },
                                on: {
                                  click: navigate,
                                  keypress: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return navigate.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("global.doorr.settings")) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3481224899
                  ),
                }),
                _vm._v(" "),
                _c("div", { staticClass: "dropleft d-lg-none d-flex" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-menu" }, [
                    _c(
                      "div",
                      { staticClass: "dropdown-item clickable wide px-4" },
                      [
                        _c("router-link", {
                          key: "settings",
                          attrs: { to: _vm.settingsToggleRoute, custom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var navigate = ref.navigate
                                  return [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-white",
                                        class: {
                                          "btn-primary": _vm.tabIsSettings,
                                        },
                                        attrs: { role: "link" },
                                        on: {
                                          click: navigate,
                                          keypress: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return navigate.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("global.doorr.settings")
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2816525581
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]
            : _vm.tabIsDocumentAutomations
            ? [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.manage-document-types-modal",
                        modifiers: { "manage-document-types-modal": true },
                      },
                    ],
                    staticClass: "btn btn-sm btn-white d-none d-lg-block",
                    attrs: { type: "button" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("documents.manageDocumentTypes")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropleft d-lg-none d-flex" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-menu" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.manage-document-types-modal",
                            modifiers: { "manage-document-types-modal": true },
                          },
                        ],
                        staticClass: "dropdown-item clickable wide px-4",
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("documents.manageDocumentTypes")) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "grey-text text-darken-4 clickable d-lg-none",
        attrs: { "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "material-icons" }, [_vm._v("more_vert")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "grey-text text-darken-4 clickable d-lg-none",
        attrs: { "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "material-icons" }, [_vm._v("more_vert")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }